(() => {
  const body = document.body;
  const drawer = document.querySelector('[data-mobile-drawer]');
  const overlay = document.querySelector('[data-drawer-overlay]');
  const openButton = document.querySelector('[data-menu-open]');
  const closeButton = document.querySelector('[data-menu-close]');

  const setDrawer = (open) => {
    if (!drawer || !overlay) return;
    drawer.classList.toggle('is-open', open);
    overlay.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    body.classList.toggle('drawer-open', open);
    openButton?.setAttribute('aria-expanded', String(open));
  };

  openButton?.addEventListener('click', () => setDrawer(true));
  closeButton?.addEventListener('click', () => setDrawer(false));
  overlay?.addEventListener('click', () => setDrawer(false));
  drawer?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setDrawer(false)));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') setDrawer(false); });

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const images = [...section.querySelectorAll('[data-gallery-image]')];
    const thumbs = [...section.querySelectorAll('[data-gallery-thumb]')];
    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => {
        images.forEach((image, imageIndex) => image.classList.toggle('is-active', imageIndex === index));
        thumbs.forEach((item, thumbIndex) => item.classList.toggle('is-active', thumbIndex === index));
      });
    });

    const quantityInput = section.querySelector('[data-quantity-input]');
    section.querySelectorAll('[data-quantity-card]').forEach((card) => {
      card.addEventListener('click', () => {
        section.querySelectorAll('[data-quantity-card]').forEach((item) => item.classList.remove('is-active'));
        card.classList.add('is-active');
        if (quantityInput) quantityInput.value = card.dataset.quantity || '1';
      });
    });

    const variantSelect = section.querySelector('[data-variant-select]');
    const price = section.querySelector('[data-product-price]');
    variantSelect?.addEventListener('change', () => {
      const option = variantSelect.options[variantSelect.selectedIndex];
      if (price && option.dataset.price) price.innerHTML = option.dataset.price;
      if (submit && option.dataset.price && !submit.disabled) submit.textContent = `Add to cart — ${option.dataset.price}`;
    });

    const purchaseRadios = section.querySelectorAll('[name="purchase_mode"]');
    const sellingPlan = section.querySelector('[data-selling-plan]');
    purchaseRadios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!sellingPlan) return;
        sellingPlan.disabled = radio.value !== 'subscription';
      });
    });

    const form = section.querySelector('[data-product-form]');
    const submit = section.querySelector('[data-product-submit]');
    form?.addEventListener('submit', async (event) => {
      if (!window.fetch || !form.action.includes('/cart/add')) return;
      event.preventDefault();
      if (submit) { submit.disabled = true; submit.dataset.originalText = submit.textContent; submit.textContent = 'Adding…'; }
      try {
        const response = await fetch(window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart/add.js` : '/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error('Unable to add this item.');
        const addedItem = await response.json();

        if (window.fbq) {
          const eventId = window.generateFbEventId
            ? window.generateFbEventId()
            : `${Date.now()}-${Math.random().toString(36).substring(2, 10)}`;
          window._fbAddToCartEventId = eventId;
          window.fbq('track', 'AddToCart', {
            content_type: 'product',
            content_ids: [String(addedItem.variant_id || addedItem.id)],
            currency: window.LumiereShop?.currency || 'USD',
            value: Number(addedItem.final_price || addedItem.price || 0) / 100,
            num_items: Number(addedItem.quantity || quantityInput?.value || 1)
          }, { eventID: eventId });
        }

        const cartResponse = await fetch(window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart.js` : '/cart.js');
        const cart = await cartResponse.json();
        document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
        if (submit) submit.textContent = 'Added to your ritual ✓';
        setTimeout(() => { if (submit) { submit.textContent = submit.dataset.originalText || 'Add to cart'; submit.disabled = false; } }, 1800);
      } catch (error) {
        if (submit) { submit.textContent = error.message; submit.disabled = false; }
      }
    });
  });
})();
